import { _ } from '../Lang.class.js';

class SearchPointForm {

    constructor(container, parameters, callbacks) {
        this.container = container;
        this.callbacks = callbacks;
        parameters = parameters || {};
        this.container.innerHTML = '<div class="area-new-point"><div class="area-new-point-search"></div><div class="area-new-point-state"></div></div><div class="area-new-point-suggest-container" style="position: relative;"><div class="area-new-point-suggest" style="position: absolute;"></div></div>';
        this.suggest = this.container.querySelector('.area-new-point-suggest');
        this.stateButton = this.container.querySelector('.area-new-point-state');
        this.suggestTO = null;
        this.lastQuery = null;
        this.coords = parameters.coords ?? null;
        this.validSearchResult = typeof(parameters.validResult) == 'function' ? parameters.validResult : function(item) { return item.type == 'coords' || (item.type == 'place' && item.objecttype == 'BUILDING'); };
        this.ftsform = new Targeo.FTSForm('ftsform', {
            placeholder: _('Address or coordinates'),
            button: false,
            history: false,
            resolveExtendedAsSuggest: true,
            suggestElement: this.suggest,
            suggestFormatItem: (function (item) {
                if (item.src && (item.src.xy || item.src.coords) && this.validSearchResult(item.src)) {
                    return item.view;
                } else {
                    return false;
                }
            }).bind(this)
        });
        this.ftsform.initialize(this.container.querySelector('.area-new-point-search'));
        this.input = this.container.querySelector('.area-new-point-search input');
        if (parameters.label) {
            this.input.value = this.lastQuery = parameters.label;
        }
        if (this.coords) {
            this.stateButton.classList.add('set');
        }
        this.addSearchFormListeners(this.ftsform);
    }

    addSearchFormListeners() {
        this.ftsform.listen('onSearchResult', (function (ev) {
            let item = false;
            if (ev.results.length) {
                for (let i = 0, ii = ev.results.length; i < ii; i++) {
                    item = ev.results[i];
                    if ((item.xy || item.coords) && this.validSearchResult(item)) {
                        break;
                    } else {
                        item = false;
                    }
                }
            }
            this.stateButton.classList.remove('changing');
            /*targeoMap.unlistenByKey(mapClickListener);
            targeoMap.modules.Controls.removeControl('dzones-bar');*/
            if (item !== false) {
                this.lastQuery = this.input.value;
                this.setCoordinate(item.type == 'coords' ? { x: item.coords.x, y: item.coords.y } : item.xy, false);
            } else if (!this.input.value || this.input.value != this.lastQuery) {
                this.unsetCoordinate();
                this.stateButton.classList.remove('set', 'changing');
                if (this.input.value) {
                    this.input.classList.add('search-point-form-error');
                    this.input.setAttribute('title', _('Address not found'));
                }
            }
        }).bind(this));
        this.ftsform.listen('onSuggestShow', (function () {
            if (this.suggestTO) {
                clearTimeout(this.suggestTO);
                this.suggestTO = null;
            }
            if (!jQuery(this.suggest).is(':empty')) {
                jQuery(this.suggest).show();
            } else {
                jQuery(this.suggest).hide();
            }
        }).bind(this));
        this.ftsform.listen('onSuggestHide', (function () {
            jQuery(this.suggest).hide();
            if (this.suggestTO) {
                clearTimeout(this.suggestTO);
            }
            if (this.input != document.activeElement) {
                this.suggestTO = setTimeout((function () {
                    if (this.input.value && this.input.value != this.lastQuery) {
                        this.input.classList.add('search-point-form-error');
                        this.input.setAttribute('title', _('Address not found'));
                        this.unsetCoordinate();
                    }
                }).bind(this), 250);
            }
        }).bind(this));
        this.ftsform.listen('onCountryTableShow', (function () {
            if (this.suggestTO) {
                clearTimeout(this.suggestTO);
                this.suggestTO = null;
            }
            jQuery(this.suggest).show();
        }).bind(this));
        this.ftsform.listen('onCountryTableHide', (function () {
            jQuery(this.suggest).hide();
            if (this.suggestTO) {
                clearTimeout(this.suggestTO);
            }
        }).bind(this));
        this.ftsform.listen('onCountrySelect', (function () {
            if (this.input.value == this.lastQuery) {
                this.lastQuery = '';
                this.input.value = '';
                this.input.setAttribute('title', '');
                this.unsetCoordinate();
            }
        }).bind(this));
        this.container.querySelector('input.targeo-ftsform-input').addEventListener('keyup', (function () {
            if (this.input.value != this.lastQuery && !this.stateButton.classList.contains('changing')) {
                this.input.classList.remove('search-point-form-error');
                this.unsetCoordinate();
                if (this.input.value) {
                    this.stateButton.classList.add('changing');
                }
            }
        }).bind(this));
        this.container.querySelector('input.targeo-ftsform-input').addEventListener('blur', (function () {
            setTimeout((function () {
                if (!this.input.value) {
                    this.stateButton.classList.remove('set', 'changing');
                } else if (this.input.value != this.lastQuery) {
                    this.ftsform.performSearch();
                }
            }).bind(this), 100);
        }).bind(this));
        this.stateButton.addEventListener('click', (function () {
            if (this.stateButton.classList.contains('changing')) {
                /*targeoMap.unlistenByKey(mapClickListener);
                mapClickListener = null;*/
                this.stateButton.classList.remove('changing');
                //targeoMap.modules.Controls.removeControl('dzones-bar');
                if (this.input.value) {
                    this.ftsform.performSearch();
                }
            } else {
                if (this.stateButton.classList.contains('set')) {
                    this.input.value = '';
                    this.unsetCoordinate();
                }
                this.stateButton.classList.add('changing');
                if (typeof(this.callbacks.onClickLocationRequest) == 'function') {
                    this.callbacks.onClickLocationRequest();
                }
            }
        }).bind(this));
    }

    setCoordinate(coords, updateField) {
        this.coords = coords;
        this.stateButton.classList.remove('changing');
        this.stateButton.classList.add('set');
        if (updateField) {
            let gpscoords = Targeo.Base.formatGPSCoords(coords);
            this.input.value = gpscoords.y + ', ' + gpscoords.x;
            this.input.classList.remove('search-point-form-error');
            this.input.setAttribute('title', '');
        }
        if (typeof(this.callbacks.onCoordinateSet) == 'function') {
            this.callbacks.onCoordinateSet(coords);
        }
    }

    unsetCoordinate() {
        this.coords = null;
        this.stateButton.classList.remove('set');
        if (typeof(this.callbacks.onCoordinateUnset) == 'function') {
            this.callbacks.onCoordinateUnset();
        }
    }

}

export default SearchPointForm;
